import { motion } from "framer-motion";
import { useState } from "react";

export default function About() {
  const [hovered, setHovered] = useState(null);

  const strengths = [
    {
      title: "Reliable & Professional",
      desc: "We deliver IT solutions with precision, ensuring minimal downtime and maximum business continuity.",
    },
    {
      title: "Secure & Compliant",
      desc: "Our solutions are designed to protect your data and meet industry-standard compliance requirements.",
    },
    {
      title: "Modern & Automated",
      desc: "We leverage the latest technologies and automation to streamline IT operations and boost efficiency.",
    },
  ];

  return (
    <section className="relative bg-[#0f111a] py-20 px-6 md:px-16 text-white overflow-hidden">
      <div className="max-w-6xl mx-auto text-center">
        {/* Section Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-4xl md:text-5xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-[#00fff7] to-[#0077ff]"
        >
          About Basore Technologies
        </motion.h2>

        {/* About Text */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 1 }}
          className="text-gray-300 max-w-3xl mx-auto text-lg md:text-xl mb-16 leading-relaxed"
        >
          Basore Technologies is a Toronto-based IT services provider specializing in enterprise-grade
          infrastructure solutions. We empower businesses with secure, automated, and intelligent IT
          systems, helping them focus on growth and innovation. Our expertise spans system administration,
          network security, virtualization, and cloud management — all delivered with reliability,
          scalability, and modern best practices.
        </motion.p>

        {/* Animated Strength Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {strengths.map((item, i) => (
            <motion.div
              key={i}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              animate={{
                scale: hovered === i ? 1.05 : 1,
                y: hovered === i ? -6 : 0,
                boxShadow:
                  hovered === i
                    ? "0 10px 25px rgba(0, 119, 255, 0.22)"
                    : "0 4px 12px rgba(0, 0, 0, 0.18)",
              }}
              transition={{
                duration: 0.35,
                ease: [0.25, 1, 0.3, 1], // smooth, spring-like
              }}
              className="p-8 bg-[#1a1f2b]/80 rounded-2xl border border-gray-800 
                         hover:border-[#00fff7] cursor-pointer transition-all 
                         duration-300 backdrop-blur-sm will-change-transform will-change-shadow"
            >
              <h3 className="text-xl font-semibold mb-3 text-[#00fff7]">
                {item.title}
              </h3>
              <p className="text-gray-300 leading-relaxed text-sm md:text-base">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-tr from-[#0f111a]/15 via-[#1a1f2b]/10 to-[#0f111a]/15 pointer-events-none -z-10"></div>
    </section>
  );
}
